/**
 * Persistent storage for invite codes.
 * Stores invite codes in localStorage so they survive app restarts and auth flows.
 */

const PENDING_INVITE_KEY = 'yapzap_pending_invite';
const PENDING_INVITE_LEAGUE_ID_KEY = 'yapzap_pending_invite_league_id';

/**
 * Store a pending invite code for processing after auth
 */
export function setPendingInvite(inviteCode: string, leagueId?: number): void {
  console.log('📨 [Invite Storage] Setting pending invite:', inviteCode, 'leagueId:', leagueId);
  localStorage.setItem(PENDING_INVITE_KEY, inviteCode);
  if (leagueId) {
    localStorage.setItem(PENDING_INVITE_LEAGUE_ID_KEY, leagueId.toString());
  }
  // Also keep in sessionStorage for backward compatibility
  sessionStorage.setItem(PENDING_INVITE_KEY, inviteCode);
}

/**
 * Get the pending invite code if one exists
 */
export function getPendingInvite(): string | null {
  // Check localStorage first (persistent), then sessionStorage (backward compat)
  const invite = localStorage.getItem(PENDING_INVITE_KEY) || sessionStorage.getItem(PENDING_INVITE_KEY);
  console.log('📨 [Invite Storage] Getting pending invite:', invite);
  return invite;
}

/**
 * Get the pending invite league ID if one exists
 */
export function getPendingInviteLeagueId(): number | null {
  const leagueId = localStorage.getItem(PENDING_INVITE_LEAGUE_ID_KEY);
  console.log('📨 [Invite Storage] Getting pending invite league ID:', leagueId);
  return leagueId ? parseInt(leagueId, 10) : null;
}

/**
 * Clear the pending invite after it's been processed
 */
export function clearPendingInvite(): void {
  console.log('📨 [Invite Storage] Clearing pending invite');
  localStorage.removeItem(PENDING_INVITE_KEY);
  localStorage.removeItem(PENDING_INVITE_LEAGUE_ID_KEY);
  sessionStorage.removeItem(PENDING_INVITE_KEY);
}

/**
 * Check if there's a pending invite waiting to be processed
 */
export function hasPendingInvite(): boolean {
  const hasInvite = !!getPendingInvite();
  console.log('📨 [Invite Storage] Has pending invite:', hasInvite);
  return hasInvite;
}

// --- Referrer tracking (for general app referrals, not just league invites) ---

const REFERRER_KEY = 'yapzap_referrer_id';

/**
 * Capture ?ref= param from any URL and store it for later attribution.
 * Call this on app load.
 */
export function captureReferrer(): void {
  const params = new URLSearchParams(window.location.search);
  const ref = params.get('ref');
  if (ref) {
    localStorage.setItem(REFERRER_KEY, ref);
  }
}

export function getPendingReferrer(): string | null {
  return localStorage.getItem(REFERRER_KEY);
}

export function clearPendingReferrer(): void {
  localStorage.removeItem(REFERRER_KEY);
}
